export const SET_NEW_TRANSACTION_REQUEST = "SET_NEW_TRANSACTION_REQUEST";
export const SET_NEW_TRANSACTION_SUCCESS = "SET_NEW_TRANSACTION_SUCCESS";
export const SET_NEW_TRANSACTION_FAILURE = "SET_NEW_TRANSACTION_FAILURE";
export const DELETE_SALE_REQUEST = "DELETE_SALE_REQUEST";
export const DELETE_SALE_SUCCESS = "DELETE_SALE_SUCCESS";
export const DELETE_SALE_FAILURE = "DELETE_SALE_FAILURE";

export const RESET_SALE_STATE = "RESET_SALE_STATE";
